module.exports = __webpack_public_path__ + "static/media/bath.390e75b1.svg";